import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import 'viewerjs/dist/viewer.css';

// import { HappyScroll } from 'vue-happy-scroll'
// Vue.component('happy-scroll', HappyScroll)
// import 'vue-happy-scroll/docs/happy-scroll.css'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
Vue.use(PerfectScrollbar)

import '@/assets/css/vars.css'
import '@/assets/css/index.scss'
import '@/assets/css/dark.scss'

Vue.config.productionTip = false

import api from '@/api.js'
import common from '@/common.js'
let pList = {
    api,
    common,
    // eslint-disable-next-line no-undef
    jump: function (url) {
        this.$router.push(url).catch(() => {
            console.log("重复点击同一个链接");
        })
    },
    cloudPic: function (url, type) {
        // eslint-disable-next-line no-undef
        return url ? u_config.cloudPic + "/" + type + "/" + url : ''
    },
}
for (const key in pList) {
    if (Object.hasOwnProperty.call(pList, key)) {
        const item = pList[key];
        Vue.prototype[key] = item;
    }
}

import uCatalogueItem from "@/components/uCatalogueItem.vue"
Vue.component("uCatalogueItem", uCatalogueItem)
import uCatalogue from "@/components/uCatalogue.vue"
Vue.component("uCatalogue", uCatalogue)

import toTop from "@/components/toTop.vue"
Vue.component("toTop", toTop)

import Clickoutside from 'element-ui/src/utils/clickoutside';
Vue.directive("Clickoutside", Clickoutside)

import buttonAuth from "@/utils/buttonAuth.js";
Vue.directive('buttonAuth', buttonAuth);

axios.get('./static/config.js?r=' + new Date().getTime()).then(res => {
    eval(res.data)
    let api = require('./api')
    Vue.prototype.api = api.default;
    let store = require('./store/index.js');
    store = store.default;
    // router.beforeEach((to, from, next) => {
    //     if (store.getters.token || to.name == 'login') {
    //         next()
    //     } else {
    //         next({ name: 'login' })
    //     }
    // })


    // eslint-disable-next-line no-undef
    Vue.prototype.u_config = u_config;
    window.uApp = new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})